<template>
  <v-dialog v-model="visible" max-width="600">
    <v-card>
      <v-card-title>
        Unsigned Notes in Other Facilities
      </v-card-title>
      <v-card-text>
        <div v-if="facilities && facilities.length">
          <alert font-size="14px">
            {{ unsignedNotesMessage }}
          </alert>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Facility Name</th>
                  <th class="text-left">Unsigned Notes</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="facility in facilities" :key="facility.id">
                  <td>{{ facility.facility_name }}</td>
                  <td>{{ facility.unsigned_note_count }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
        <div v-else>
          No facilities with unsigned notes.
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <btn
          color="primary"
          :icon="icons.mdiClose"
        @click="closeDialog()">Close</btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiClose } from '@mdi/js';

export default {
  name: 'UserFacilitiesWithUnsignedNotes',
  props: {
    facilities: {
      type: Array,
      required: false,
      default: null
    },
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      icons: {
        mdiClose,
      }
    }
  },
  computed: {
    unsignedFacilitiesCount() {
      return Array.isArray(this.facilities) ? this.facilities.length : 0
    },
    totalUnsignedNotes() {
      return (this.facilities || []).reduce(
        (sum, facility) => sum + (facility.unsigned_note_count || 0),
        0
      )
    },
    unsignedNotesMessage() {
      const facilityCount = this.unsignedFacilitiesCount
      const noteCount = this.totalUnsignedNotes

      const facilityText = facilityCount === 1 ? 'facility' : 'facilities'
      const noteText = noteCount === 1 ? 'an unsigned note' : 'unsigned notes'
      const verb = facilityCount === 1 ? 'is' : 'are'

      return `You have ${noteText} in the following ${facilityText} that ${verb} not currently part of your active list.`
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close');
      window.location.reload();
    }
  }
}
</script>
